import React from "react";
import "./styles/TypeIconReturner.scss";
import Masks from "../VectorIcons/Masks";
import Microphone from "../VectorIcons/Microphone";
import ResearchesIcon from "../VectorIcons/ResearchesIcon";
import LiteraryWorkIcon from "../VectorIcons/LiteraryWorkIcon";

const ICON_COLOR_ON_BACKGROUND = "#fff";

const CONTENT_TYPES = {
  dramaturgy: { color: "#ec1045", Icon: Masks },
  variety: { color: "#2d76d4", Icon: Microphone },
  research: { color: "#009c69", Icon: ResearchesIcon },
  literaryWork: { color: "#DF9A37", Icon: LiteraryWorkIcon },
};

// Lowercased values accepted for `type` (API enums, PT-BR labels, slugs) -> CONTENT_TYPES key.
const TYPE_ALIASES = {
  dramaturgy: "dramaturgy",
  dramaturgyproduct: "dramaturgy",
  dramaturgia: "dramaturgy",
  variety: "variety",
  varietyproduct: "variety",
  variedade: "variety",
  variedades: "variety",
  research: "research",
  pesquisa: "research",
  literarywork: "literaryWork",
  "obra-literaria": "literaryWork",
  "obra literária": "literaryWork",
};

const TypeIconReturner = ({
  type,
  showBackgroundColor = false,
  responsiveIcon = false,
}) => {
  if (!type) return null;

  const contentType = CONTENT_TYPES[TYPE_ALIASES[type.toLowerCase()]];

  return (
    <div
      className={`typeIconReturner ${responsiveIcon ? "responsiveIcon" : ""}`}
      style={
        showBackgroundColor && contentType
          ? { backgroundColor: contentType.color }
          : undefined
      }
    >
      {contentType && (
        <contentType.Icon
          color={
            showBackgroundColor ? ICON_COLOR_ON_BACKGROUND : contentType.color
          }
        />
      )}
    </div>
  );
};

export default TypeIconReturner;
